import React from 'react';
import { Paper } from '@mui/material';

/**
 * Standard panel wrapper used by every brand dashboard page.
 *
 * Drops the boilerplate of repeating the same borderRadius / padding /
 * shadow on every page. Layers `sx` overrides on top so callers can tweak
 * per-page without forking the component.
 *
 * Used for page panels and for cards inside them, so it keeps all four
 * corners. The one panel that sits directly under the section's bar has its
 * top-left squared by the layout instead — doing it here would flatten every
 * card on the page too.
 */
export default function PagePaper({ children, sx, ...rest }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '20px',
        p: { xs: '20px', md: '28px' },
        // On a dark page a 4%-black shadow is invisible; the card would be
        // separated only by its own fill. Deepen it so the layering survives.
        boxShadow: (t) => (t.palette.mode === 'dark'
          ? '0 4px 16px rgba(0,0,0,0.45)'
          : '0 4px 16px rgba(0,0,0,0.04)'),
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
}
